import { ObjectOfStringValue } from './../../../../../../../intelligence/pages/GlobalView/MarketSize/hooks/useQuery';
// 图表颜色
const COLORS_0: Array<string >= ['#5086F3', '#69D19C', '#6E7794', '#F8D74D', '#7F6FF1', '#5EC8F1', '#AD53D4', '#F19E55', '#488E89', '#F17C86'];
const COLORS_1: typeof COLORS_0 = ['#A6C9FF', '#C0EBD2', '#B8BED1', '#FFF196', '#D2C8FD', '#B5EFFF', '#DFB2ED', '#FFD8AB', '#A9C7C3', '#FFCCCC'];
const COLORS_2: typeof COLORS_0 = ['#CFE4FF', '#DEF2E4', '#DFE5ED', '#FFF9BF', '#EFEBFF', '#DEF9FF', '#F3D9FA', '#FFECD4', '#DCE6E4', '#FFE6E6'];
const COLORS_3: typeof COLORS_0 = ['#2648A6', '#358561', '#2E3247', '#A8831D', '#413CA6', '#307DA6', '#642787', '#A65B29', '#245552', '#245552'];
const COLORS_4: typeof COLORS_0= ['#0F1E59', '#13382A', '#000000', '#5C410A', '#1B1C59', '#153D59', '#270D3B', '#592911', '#0A1B1C', '#591F2C'];


const COLORS: Array<typeof COLORS_0>= [COLORS_0, COLORS_1, COLORS_4, COLORS_3, COLORS_2];

const CHART_TYPE_ICON: ObjectOfStringValue = {
  'line': 'discount-chart',
  'bar': 'column-chart',
  'pie': 'pie-chart-icon',
  'table': 'sheet',
  'discount-chart': 'line',
  'column-chart': 'bar',
  'pie-chart-icon': 'bar',
  'sheet': 'table',
  'ranking':'histogram-skew',
  'histogram-skew':'ranking'
};

 const chartOptions: { [key: string]: any } = {
  textStyle: {
    fontFamily: 'Roboto Regular,-apple-system,PingFang SC,microsoft yahei ui,microsoft yahei,sans-serif'
  },
  tooltip: {
    show: true,
    trigger: 'axis',
    backgroundColor: 'rgba(38, 40, 50, 0.95)',
    borderWidth: 0,
    borderRadius: 6,
    textStyle: {
      color: '#FFFFFF',
      fontSize: 12,
    },
    axisPointer: {
      type: 'cross', // 十字线，表示启用两个正交的轴，还可为'line'，'none'，'shadow'
      axis: 'x', // 可以定义轴 'x','y','radius','angle'，一般是x轴
      label: {
        show: true,
        backgroundColor: '#fff',
        color: '#262832',
        fontWeight: 'bold',
        fontSize:12,
      },
      crossStyle: {
        color: 'transparent'
      },
      lineStyle: {
        color: '#b4b5b8',
        type: [0, 0],
        dashOffset: 10,
        width: 2,
        opacity:0.45,
      }
    },
    confine: true,
    hideDelay: 200,
    triggerOn: 'mousemove',
    // triggerOn: 'click',
    // alwaysShowContent: true,
    padding: 0,
  },
  grid: {
    containLabel: true,
    height: 320,
    left: 4,
    // right: 6,
    right: 22,
    top: 20,
  },
  xAxis: {
    type: 'category',
    // type: 'time',
    interval: 1,
    axisLabel: {
      color: '#838697',
      fontSize: 12,
      align: 'center',
      interval: 'auto',
      // formatter: '{yyyy}-{MM}-{dd}',
      hideOverlap: true,
      showMinLabel: true,
    },
    'splitLine': {
      'show': false,
    },
    axisTick: {
      show: true,
      alignWithLabel: true,
      interval: 'auto',
    },
    axisLine: {
      lineStyle: {
        color: '#D8DAE4',	
      },
      show: true
    },
    axisPointer: {
      type: 'line',
    },
  },
  axisLabel: {
    showMinLabel: true, // 强制显示最小值
  },
  yAxis: {
    type: 'value',
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dashed',
        color: '#ddd',
      },
    },
    axisLabel: {
      color: '#838697',
      fontSize: 12,
    },
    axisPointer: {
      label: {
        show: false
      }
    },
  },
  legend: {
    show: true,
    type: 'scroll',
    selectedMode: true,
    orient: 'horizontal',
    itemHeight: 8,
    itemWidth: 8,
    icon: 'circle',
    itemGap: 18,
    pageIconColor: '#444444', // 翻页下一页的三角按钮颜色
    pageIconInactiveColor: '#888888', // 翻页（即翻页到头时）
    pageIconSize: 12, // 翻页按钮大小
    pageButtonPosition: 'end', // start
    left: 'center',
    textStyle: { // 图例文字的样式
      color: '#838697',
      fontSize: 12,
      lineHeight: 16,
    },
    selectorPosition: 'start',
    selectorLabel: {
      borderWidth: 0,
      color: '#525464',
    }
  },
  barMaxWidth: 80
}; 

export {
  COLORS,
  CHART_TYPE_ICON,
  chartOptions
};